import { Grid, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../../../../theme";
import PropTypes from "prop-types";

interface Props {
  statisticTitle: string;
  statisticFigure: number | null;
}

export const StatisticsCard: React.FC<Props> = ({
  statisticFigure,
  statisticTitle,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Grid
      size={{ xs: 6, sm: 3 }}
      sx={{
        backgroundColor: colors.primary[900],
        padding: { xs: 1.5, sm: 2.5 },
        borderRadius: 2,
        border: "1px solid #f1f5f9",
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: 22, sm: 28 },
          fontWeight: 700,
          color: "#1e293b",
          lineHeight: 1,
        }}
      >
        {statisticFigure}
      </Typography>
      <Typography
        sx={{ fontSize: { xs: 13, sm: 16 }, color: "text.secondary", mt: 0.5 }}
      >
        {statisticTitle}
      </Typography>
    </Grid>
  );
};

StatisticsCard.propTypes = {
  statisticTitle: PropTypes.string.isRequired,
  statisticFigure: PropTypes.number,
};
